import React from 'react';
interface PlusButtonProps {
  size?: 'sm' | 'lg';
  className?: string;
}
export function PlusButton({
  size = 'sm',
  className = ''
}: PlusButtonProps) {
  const isLg = size === 'lg';
  return <div className={`has-radius bg-white flex items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors rounded-full ${className}`} style={{
    width: isLg ? '75px' : '37.5px',
    height: isLg ? '75px' : '37.5px',
    borderRadius: '50%'
  }} data-id="element-203">
      <span style={{
      color: isLg ? '#090909' : '#000',
      fontFamily: 'Poppins, sans-serif',
      fontSize: isLg ? '56.25px' : '37.5px',
      fontStyle: 'normal',
      fontWeight: isLg ? 700 : 800,
      lineHeight: 'normal'
    }} data-id="element-204">
        +
      </span>
    </div>;
}